import { store } from '../store/store';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';

export default function ClientSideWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Provider store={store}>
      <Toaster position="top-center" reverseOrder={false} />
      {children}
    </Provider>
  );
}
